export const dict = {
    standardCoverageTooltip:
        '<p><strong>Standard coverage</strong>:</p><p>Our Underwriters will review and approve designated General Contractor (GC) in order to remove them from any conditions of coverage on form U658OI.</p>',
    conditionalCoverageTooltip:
        '<p><strong>Conditional coverage</strong>: 20% discount off base premium</p><p>It is understood coverage is subject to all direct hired contractors meeting the conditions of coverage outlined in form U658OI-0617.</p>',
    biExcludedCoverageTooltip:
        '<p><strong>BI Excluded coverage</strong>: 40% discount off base premium</p><p>Coverage excludes Bodily Injury to Employees and Subcontractor Employees. Coverage is subject to all direct hired contractors meeting the conditions of coverage outlined in form U286OI-0617.',
    additionalPollution:
        '<p>Will remove Total Pollution Exclusion Endorsement (CG2149-0999) and replace with Total Pollution Exclusion with a Hostile Fire Exception (CX2103-0413)</p>',
    additionalSubsidence: '<p>Will remove Subsidence Exclusion (U253-0621)</p>',
    additionalExtendedCompletedOps:
        '<p>Will add Extended Products-Completed Hazard Operations Endorsement (U446-1007) up to the individual State Statute of Repose, up to a max of 10 years</p>',
    accordion: {
        deductibleWarranty: {
            head: 'Deductible Warranty',
            subHeader: '',
            body:
                'Our Underwriters will review and approve one direct hired contractor for use of the U653 prior to binding.',
            footer: ''
        },
        standard: {
            head: 'Standard coverage',
            subHeader: '',
            body:
                'Our Underwriters will review and approve designated General Contractor (GC) in order to remove them from any conditions of coverage on form U658OI.',
            footer: ''
        },
        conditional: {
            head: 'Conditional coverage',
            subHeader: '20% discount off base premium',
            body:
                'It is understood coverage is subject to all direct hired contractors meeting the conditions of coverage outlined in form U658OI.',
            footer: ''
        },
        biExcluded: {
            head: 'BI Excluded coverage',
            subHeader: '40% discount off base premium',
            body:
                'Coverage excludes Bodily Injury to Employees and Subcontractor Employees. Coverage is subject to all direct hired contractors meeting the conditions of coverage outlined in form U658OI LLE.',
            footer: ''
        },
        isPCOpsExcluded: {
            head: 'Products Completed Operations Exclusion',
            subHeader: '',
            newyork: '5% discount off base premium',
            default: '10% discount off base premium',
            isPCOpsExcluded: true,
            body:
                `<span style="font-size:12px"> Note- When the Base Rate is ‘Minimum Premium’, discount will not get applied to base premium.</span><br><br>
                Will exclude Products-Completed Hazard Operations Endorsement ( CG2104 ).`,
            footer: ''
        },
        isESWorkExcluded: {
            head: 'Products Completed External Exclusion',
            isESWorkExcluded: true,
        },
        tria: {
            head: 'Terrorism coverage',
            default: '5% of base premium',
            subHeader: '',
            otherStates: '3% of base premium',
            Ohio: '5% of base premium',
            Florida: '1% of base premium',
            body:
                'Insured must elect or reject coverage by completing TRIA form at binding (attached to quote).',
            footer: ''
        },
        identityRecovery: {
            head: '',
            subHeader: '',
            body:
                'Optional Coverage for submissions with premium under $25,000.  Mandatory Coverage for submissions with premium greater than $25,000.  ',
            footer: ''
        },
        hnoa: {
            head: '',
            subHeader: '',
            body:
                'Will include Hired and Non-Owned Auto endorsement ( U132C )',
            footer: ''
        },
        additionalPollution: {
            head: '',
            subHeader: '',
            body:
                'Will remove Total Pollution Exclusion Endorsement ( CG2149 ) and replace with Total Pollution Exclusion with a Hostile Fire Exception ( CG2155 )',
            footer: ''
        },
        additionalSubsidence: {
            head: '',
            subHeader: '',
            body:
                'Will remove Subsidence Exclusion ( U253 )',
            footer: ''
        },
        additionalExtendedCompletedOps: {
            head: '',
            subHeader: '',
            body:
                'Will add Extended Products-Completed Hazard Operations Endorsement ( U446 ) up to the individual State Statute of Repose, up to a max of 10 years',
            footer: ''
        },
        additionalBanksMortgagees: {
            head: '',
            subHeader: '',
            body:
                '$250 charged per form and for naming Bank/ Mortgagees',
            footer: ''
        },
        additionalInsuredAddition: {
            head: '',
            subHeader: '',
            body:
                '$250 charged per form',
            footer: ''
        },
        standardOcp: {
            head: 'OCP Coverage',
            subHeader: '',
            body: 'This OCP quotation is restricted to the applicant hiring a specified General Contactor which will be designated on the policy. Such designation will occur after carrier reviews and accepts the risk transfer documents and confirms their coverage is adequate as per form OCP008A.',

        }
    }
};
